<template>
  <div class="action-menu" @click.stop>
    <el-button v-if="primary" link type="primary" :disabled="primary.disabled" @click="primary.onClick()">{{ primary.label }}</el-button>
    <el-dropdown v-if="actions.length" trigger="click" @command="runAction">
      <el-button text aria-label="更多操作">更多<el-icon><ArrowDown /></el-icon></el-button>
      <template #dropdown><el-dropdown-menu><el-dropdown-item v-for="(action, index) in actions" :key="action.label" :command="index" :disabled="action.disabled" :class="{ 'action-menu__danger': action.danger }">{{ action.label }}</el-dropdown-item></el-dropdown-menu></template>
    </el-dropdown>
  </div>
</template>
<script setup lang="ts">
import { ArrowDown } from '@element-plus/icons-vue'
type Action = { label: string; onClick: () => unknown; disabled?: boolean; danger?: boolean }
const props = withDefaults(defineProps<{ primary?: Action; actions?: Action[] }>(), { actions: () => [] })
function runAction(index: number) { const action = props.actions[index]; if (action && !action.disabled) action.onClick() }
</script>
<style scoped>.action-menu { display: inline-flex; align-items: center; gap: 8px; white-space: nowrap; } .action-menu__danger { color: var(--ui-danger); }</style>
